import React, { useEffect, useState, useCallback, useRef } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { Form, Radio, Checkbox, Icon, Dropdown } from "semantic-ui-react";
import {
  Container,
  Field,
  InlineField,
  CheckBoxField,
  Title,
  Input,
  InputFile,
  Select,
  Label,
  Textarea,
  Button,
  Error
} from "./styled";
import swal from "sweetalert";
import NewTextEditor from "../../../../components/Admin/NewTextEditor";
import { isAuthAdmin } from "../../../../services/auth";
import { systemLogs } from "../../../../services/system_logs";

const CreateCurso = ({ history }) => {
  const [tipo, setTipo] = useState("0");
  const [idTreinamento, setIdTreinamento] = useState(0);
  const [idColaboradores, setIdColaboradores] = useState(0);
  const [titulo, setTitulo] = useState("");
  const [contatoEmail, setContatoEmail] = useState("contato@voitto.com.br");
  const [valor, setValor] = useState(0);
  const [vagas, setVagas] = useState(0);
  const [ativo, setAtivo] = useState(0);
  const [numeroVideos, setNumeroVideos] = useState(0);
  const [cargaHoraria, setCargaHoraria] = useState(0);
  const [obs, setObs] = useState("");
  const [urlAmigavel, setUrlAmigavel] = useState("");
  const [lang, setLang] = useState("pt-BR");
  const [area, setArea] = useState(0);
  const [areas, setAreas] = useState([]);
  const [treinamentos, setTreinamentos] = useState([]);
  const [consultores, setConsultores] = useState([]);
  const [materialImpresso, setMaterialImpresso] = useState(false);
  const [certificadoImpresso, setCertificadoImpresso] = useState(false);
  const [listarCurso, setListarCurso] = useState(false);
  const certificadoDescription = useRef("");
  const [novo, setNovo] = useState(0);
  const [nivelCurso, setNivelCurso] = useState("");
  const [allIn, setAllIn] = useState("1");
  const [imagemComboMobile, setImagemComboMobile] = useState("");
  const [imagemDesktop, setImagemDesktop] = useState("");
  const [ordem, setOrdem] = useState("");
  const [errors, setErrors] = useState({
    nomeCurso: "",
    contatoEmail: "",
    urlAmigavel: "",
  });

  const [dates, setDates] = useState([
    {
      data: "",
      hora_inicial: "",
      hora_final: "",
    },
  ]);

  const [images, setImages] = useState({
    capa: "",
    // detalhamentoCurso: "",
    // imagemFundoCabecario: "",
    // imagemComboMobile: "",
    // imagemDesktop: "",
  });

  const activeOptions = [
    { id: "S", descricao: "Sim" },
    { id: "N", descricao: "Não" },
  ];

  const yesOrNoOptions = [
    { id: 1, descricao: "Sim" },
    { id: 0, descricao: "Não" },
  ];

  const nivelCursoOptions = [
    { id: 1, descricao: "Básico ao avançado" },
    { id: 2, descricao: "Iniciantes" },
    { id: 3, descricao: "Intermediário" },
    { id: 4, descricao: "Avançado" },
  ];

  const languages = [
    { id: 0, descricao: "pt-BR" },
    { id: 1, descricao: "en-US" },
  ];

  useEffect(() => {
    loadAuth();

    const getOptions = async () => {
      const areas = (await api.get("/area-descricao")).data;
      const treinamentos = (
        await api.get("admin/treinamentos?all=1", {
          headers: {
            access_token: `voitto-token ${localStorage.getItem("oauth_token")}`,
          },
        })
      ).data;
      const consultores = (await api.get("consultor?all=1")).data;

      setAreas(areas);
      setTreinamentos(treinamentos);
      setConsultores(consultores);
    };

    getOptions();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const verifyErrors = () => {
    setErrors({
      contatoEmail: '',
      nomeCurso: '',
      urlAmigavel: '',
    })
    let error = false;
    if (!titulo) {
      setErrors((prev) => ({ ...prev, nomeCurso: "Campo obrigatório" }));
      error = true;
    }
    if (!urlAmigavel) {
      setErrors((prev) => ({ ...prev, urlAmigavel: "Campo obrigatório" }));
      error = true;
    }
    if (!contatoEmail) {
      setErrors((prev) => ({ ...prev, contatoEmail: "Campo obrigatório" }));
      error = true;
    }
    if (error) {
      swal(
        "Erro ao criar curso",
        "Por favor, verifique os campos obrigatórios",
        "error"
      );
      return true;
    };
    return false;
  };

  const handleSubmit = useCallback(async () => {
    const error = verifyErrors();
    if(error) return ;

    let payload = {
      tipo: tipo,
      id_treinamento: idTreinamento,
      id_colaborador: idColaboradores,
      description_certificado: certificadoDescription.current,
      area_corporativo: area,
      curso: titulo,
      contato_email: contatoEmail,
      valor: valor,
      valorAllIn: allIn,
      vagas: vagas,
      ativo: ativo,
      numero_videos: numeroVideos,
      carga_horaria: cargaHoraria,
      obs: obs,
      url_amigavel: urlAmigavel,
      lang: lang,
      listar: listarCurso ? 1 : 0,
      hascertificate: certificadoImpresso ? 1 : 0,
      hasmaterial: materialImpresso ? 1 : 0,
      novo: novo,
      nivel: nivelCurso,
      dates: tipo === 6 ? dates.filter((date) => !!date.data) : [],
      imagem_mobile: imagemComboMobile,
      imagem_web: imagemDesktop,
      ordem,
      isAddToAllIn: allIn
    };

    try {
      const res = await api.post("/admin/curso", payload);
      await systemLogs("curso", `criou o curso de id${res.data.curso.id}`);
      await uploadContent("capa", "cursos/new_dash");
      // await uploadContent("detalhamentoCurso", "cursos/slides");
      // await uploadContent("imagemFundoCabecario", "cursos/covers");
    } catch (err) {
      swal(
        "Erro ao criar curso",
        err?.message || "Por favor, verifique se todos os campos estão preenchidos corretamente",
        "error"
      );

      return;
    }

    history.push("/admin/cursos/ativos");
  }, [
    images,
    tipo,
    idTreinamento,
    idColaboradores,
    area,
    titulo,
    contatoEmail,
    valor,
    allIn,
    vagas,
    ativo,
    numeroVideos,
    cargaHoraria,
    certificadoDescription,
    obs,
    urlAmigavel,
    lang,
    listarCurso,
    certificadoImpresso,
    materialImpresso,
    novo,
    nivelCurso,
  ]);

  const uploadContent = useCallback(
    async (file, folder) => {

      const formData = new FormData();

      formData.append("file", images[file]);
      formData.append("folder", folder);
      formData.append("url", urlAmigavel);

      await api.post("/curso/upload-content", formData).catch(() => {
        throw new Error("Erro ao enviar o arquivo. Verifique se o formato é adequado (imagens: .jpg/.png, slides: .pdf)");
      });
    },
    [images, urlAmigavel]
  );

  const changeDate = useCallback(
    (e, index) => {
      dates[index][e.target.name] = e.target.value;
      setDates([...dates]);
    },
    [dates]
  );

  const addDate = useCallback(() => {
    dates.push({
      data: "",
      hora_inicial: "",
      hora_final: "",
    });
    setDates([...dates]);
  }, [dates]);

  return (
    <Container>
      <Title>Criar Curso</Title>

      <Form>
        <CheckBoxField>
          <Label>Tipo do curso</Label>
          <Radio
            label="Online"
            name="radioGroup"
            value={3}
            checked={tipo === 3}
            onChange={() => setTipo(3)}
          />

          <Radio
            label="Ao Vivo"
            name="radioGroup"
            value={6}
            checked={tipo === 6}
            onChange={() => setTipo(6)}
          />
        </CheckBoxField>

        <Field>
          <Label>Nome do curso</Label>
          <Input
            name="tituloCurso"
            value={titulo}
            onChange={(e) => setTitulo(e.target.value)}
          />
          {errors.nomeCurso && <Error>{errors.nomeCurso}</Error>}
        </Field>

        <Field>
          <Label>Ordem do curso</Label>
          <Input
            type={"number"}
            name="ordemCurso"
            onChange={(e) => setOrdem(e.target.value)}
            value={ordem}
          />
        </Field>

        <InlineField>
          <Field>
            <Label>Área Corporativo</Label>
            <Select name="areaCurso" onChange={(e) => setArea(e.target.value)}>
              <option value={0}>Nenhuma área em específica</option>

              {areas.map((area) => (
                <option value={area?.areacorp.id}>
                  {area?.areacorp.nome_tab}
                </option>
              ))}
            </Select>
          </Field>

          <Field>
            <Label>Treinamento</Label>
            <Select
              name="treinamento"
              onChange={(e) => setIdTreinamento(e.target.value)}
            >
              {treinamentos.map((treinamento) => (
                <option value={treinamento.id}>{treinamento.nome}</option>
              ))}
            </Select>
          </Field>
        </InlineField>

        <Field>
          <Label>Nível do curso</Label>
          <Select
            name="nivelCurso"
            onChange={(e) => setNivelCurso(e.target.value)}
          >
            <option value="" hidden>
              Selecione
            </option>

            {nivelCursoOptions.map((nivel) => (
              <option value={nivel.descricao}>{nivel.descricao}</option>
            ))}
          </Select>
        </Field>

        <Field>
          <Label>Esse curso fará parte do All In</Label>
          <Select name="allIn" onChange={(e) => setAllIn(e.target.value)}>
            {yesOrNoOptions.map((opcao) => (
              <option value={opcao.id}>{opcao.descricao}</option>
            ))}
          </Select>
        </Field>

        <Field>
          <Label>Url do Curso</Label>
          <Input name="url" onChange={(e) => setUrlAmigavel(e.target.value)} />
          {errors.urlAmigavel && <Error>{errors.urlAmigavel}</Error>}
        </Field>

        <Field>
          <Label>Observação</Label>
          <Textarea
            name="obs"
            cols="10"
            rows="10"
            onChange={(e) => setObs(e.target.value)}
          ></Textarea>
        </Field>

        {tipo == 6 && (
          <div style={{ marginTop: "32px", marginBottom: "32px" }}>
            <div style={{ marginBottom: "16px" }}>
              {dates.map((date, index) => (
                <div style={{ display: "flex", marginBottom: "8px" }}>
                  <InlineField style={{ marginRight: "16px" }}>
                    <Label style={{ marginRight: "16px" }}>
                      Data{index + 1}:{" "}
                    </Label>
                    <input
                      name="data"
                      type="date"
                      value={date.data}
                      onChange={(e) => changeDate(e, index)}
                    />
                  </InlineField>

                  <InlineField style={{ marginRight: "16px" }}>
                    <Label style={{ marginRight: "16px" }}>
                      Hora Inicial:{" "}
                    </Label>
                    <input
                      name="hora_inicial"
                      type="time"
                      value={date.hora_inicial}
                      onChange={(e) => changeDate(e, index)}
                    />
                  </InlineField>

                  <InlineField>
                    <Label style={{ marginRight: "16px" }}>Hora Final: </Label>
                    <input
                      name="hora_final"
                      type="time"
                      value={date.hora_final}
                      onChange={(e) => changeDate(e, index)}
                    />
                  </InlineField>
                </div>
              ))}
            </div>

            <Button width="160px" onClick={() => addDate()}>
              <Icon name="plus" /> Adicionar Data
            </Button>
          </div>
        )}

        <Field>
          <Label>Consultor</Label>
          <Dropdown
            name="consultor"
            search
            placeholder="Consultor"
            fluid
            selection
            multiple
            value={idColaboradores}
            options={consultores.map((consultor) => ({
              id: consultor.id,
              value: consultor.id,
              text: consultor.nome,
            }))}
            onChange={(e, { value }) => setIdColaboradores(value)}
          />
        </Field>

        <Field>
          <Label>E-mail de contato</Label>
          <Input
            name="emailContato"
            onChange={(e) => setContatoEmail(e.target.value)}
            value={contatoEmail}
          />
          {errors.contatoEmail && <Error>{errors.contatoEmail}</Error>}
        </Field>

        <Field>
          <Label>Valor do curso</Label>
          <Input name="valorCurso" onChange={(e) => setValor(e.target.value)} />
        </Field>

        <Field>
          <Label>Numero de Vagas</Label>
          <Input name="vagasCurso" onChange={(e) => setVagas(e.target.value)} />
        </Field>

        <Field>
          <Label>Carga horária</Label>
          <Input
            name="cargaHoraria"
            onChange={(e) => setCargaHoraria(e.target.value)}
          />
        </Field>

        <Field>
          <Label>Número de vídeos</Label>
          <Input
            name="quantidadeVideos"
            onChange={(e) => setNumeroVideos(e.target.value)}
          />
        </Field>

        <Title>Meta Tag</Title>

        <Field>
          <Label>Idioma do curso</Label>
          <Select name="idiomaCurso" onChange={(e) => setLang(e.target.value)}>
            {languages.map((opcao) => (
              <option value={opcao.id}>{opcao.descricao}</option>
            ))}
          </Select>
        </Field>

        <Field>
          <Label>Capa do Curso</Label>
          <InputFile
            name="capa"
            type="file"
            onChange={(e) => {
              const capa = e.target.files[0];
              setImages({ ...images, capa });
            }}
          />
        </Field>

        <Field>
          <Label>Novo</Label>
          <Select name="novo" onChange={(e) => setNovo(e.target.value)}>
            {yesOrNoOptions.map((opcao) => (
              <option value={opcao.id}>{opcao.descricao}</option>
            ))}
          </Select>
        </Field>

        <Field>
          <Checkbox
            name="certificadoImpresso"
            label="Emitir certificado ?"
            onChange={() => setCertificadoImpresso(!certificadoImpresso)}
          />
        </Field>

        <Field>
          <Label>Descrição no certificado</Label>
          <NewTextEditor
            haveFullscreen
            default={certificadoDescription}
            text={certificadoDescription}
          />
        </Field>

        <Field>
          <Checkbox
            name="materialImpresso"
            label="Tem Material para Imprimir ?"
            onChange={() => setMaterialImpresso(!materialImpresso)}
          />
        </Field>

        <Field>
          <Checkbox
            name="listarCurso"
            label="Listar curso:"
            onChange={() => setListarCurso(!listarCurso)}
          />
        </Field>

        <Field>
          <Label>Ativo</Label>
          <Select name="ativo" onChange={(e) => setAtivo(e.target.value)}>
            {activeOptions.map((opcao) => (
              <option value={opcao.id}>{opcao.descricao}</option>
            ))}
          </Select>
        </Field>

        <Button onClick={handleSubmit}>
          <Icon name="save" />
          Salvar
        </Button>
      </Form>
    </Container>
  );
};

export default CreateCurso;
